// this component loads the image frames used in the CSS animations of the "your path" section,
// to avoid flickering on first load. It enables us to load all the images before we trigger the
// animation.

import React from "react";
import Line1_preload1 from "../../../Assets/Images/Wizard/Line-1-frames/10.svg";
import Line1_preload2 from "../../../Assets/Images/Wizard/Line-1-frames/20.svg";
import Line1_preload3 from "../../../Assets/Images/Wizard/Line-1-frames/30.svg";
import Line1_preload4 from "../../../Assets/Images/Wizard/Line-1-frames/40.svg";
import Line1_preload5 from "../../../Assets/Images/Wizard/Line-1-frames/50.svg";
import Line1_preload6 from "../../../Assets/Images/Wizard/Line-1-frames/60.svg";
import Line1_preload7 from "../../../Assets/Images/Wizard/Line-1-frames/70.svg";
import Line1_preload8 from "../../../Assets/Images/Wizard/Line-1-frames/80.svg";
import Line1_preload9 from "../../../Assets/Images/Wizard/Line-1-frames/90.svg";
import Line1_preload10 from "../../../Assets/Images/Wizard/Line-1-frames/100.svg";
import Line1_preload11 from "../../../Assets/Images/Wizard/Line-1-frames/110.svg";
import Line1_preload12 from "../../../Assets/Images/Wizard/Line-1-frames/120.svg";
import Line1_preload13 from "../../../Assets/Images/Wizard/Line-1-frames/130.svg";
import Line1_preload14 from "../../../Assets/Images/Wizard/Line-1-frames/140.svg";

import Line2_preload1 from "../../../Assets/Images/Wizard/Line-2-frames/10.svg";
import Line2_preload3 from "../../../Assets/Images/Wizard/Line-2-frames/30.svg";
import Line2_preload4 from "../../../Assets/Images/Wizard/Line-2-frames/40.svg";
import Line2_preload5 from "../../../Assets/Images/Wizard/Line-2-frames/50.svg";
import Line2_preload6 from "../../../Assets/Images/Wizard/Line-2-frames/60.svg";
import Line2_preload7 from "../../../Assets/Images/Wizard/Line-2-frames/70.svg";
import Line2_preload8 from "../../../Assets/Images/Wizard/Line-2-frames/80.svg";

import Line3_preload1 from "../../../Assets/Images/Wizard/Line-3-frames/10.svg";
import Line3_preload2 from "../../../Assets/Images/Wizard/Line-3-frames/20.svg";
import Line3_preload3 from "../../../Assets/Images/Wizard/Line-3-frames/30.svg";
import Line3_preload4 from "../../../Assets/Images/Wizard/Line-3-frames/40.svg";
import Line3_preload5 from "../../../Assets/Images/Wizard/Line-3-frames/50.svg";
import Line3_preload6 from "../../../Assets/Images/Wizard/Line-3-frames/60.svg";
import Line3_preload7 from "../../../Assets/Images/Wizard/Line-3-frames/70.svg";

import Line4_preload1 from "../../../Assets/Images/Wizard/Line-4-frames/10.svg";
import Line4_preload2 from "../../../Assets/Images/Wizard/Line-4-frames/20.svg";
import Line4_preload3 from "../../../Assets/Images/Wizard/Line-4-frames/30.svg";
import Line4_preload4 from "../../../Assets/Images/Wizard/Line-4-frames/40.svg";
import Line4_preload5 from "../../../Assets/Images/Wizard/Line-4-frames/50.svg";
import Line4_preload6 from "../../../Assets/Images/Wizard/Line-4-frames/60.svg";
import Line4_preload7 from "../../../Assets/Images/Wizard/Line-4-frames/70.svg";
import Line4_preload8 from "../../../Assets/Images/Wizard/Line-4-frames/80.svg";
import Line4_preload9 from "../../../Assets/Images/Wizard/Line-4-frames/90.svg";
import Line4_preload10 from "../../../Assets/Images/Wizard/Line-4-frames/100.svg";
import Line4_preload11 from "../../../Assets/Images/Wizard/Line-4-frames/110.svg";
import Line4_preload12 from "../../../Assets/Images/Wizard/Line-4-frames/120.svg";
import Line4_preload13 from "../../../Assets/Images/Wizard/Line-4-frames/130.svg";
import Line4_preload14 from "../../../Assets/Images/Wizard/Line-4-frames/140.svg";

import Line1M_preload1 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/10.svg";
import Line1M_preload2 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/20.svg";
import Line1M_preload3 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/30.svg";
import Line1M_preload4 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/40.svg";
import Line1M_preload5 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/50.svg";
import Line1M_preload6 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/60.svg";
import Line1M_preload7 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/70.svg";
import Line1M_preload8 from "../../../Assets/Images/Wizard/Mobile-frames/Line-1/80.svg";

import Line2M_preload1 from "../../../Assets/Images/Wizard/Mobile-frames/Line-2/10.svg";
import Line2M_preload3 from "../../../Assets/Images/Wizard/Mobile-frames/Line-2/30.svg";
import Line2M_preload4 from "../../../Assets/Images/Wizard/Mobile-frames/Line-2/40.svg";
import Line2M_preload5 from "../../../Assets/Images/Wizard/Mobile-frames/Line-2/50.svg";

import Line3M_preload1 from "../../../Assets/Images/Wizard/Mobile-frames/Line-3/10.svg";
import Line3M_preload2 from "../../../Assets/Images/Wizard/Mobile-frames/Line-3/20.svg";
import Line3M_preload3 from "../../../Assets/Images/Wizard/Mobile-frames/Line-3/30.svg";
import Line3M_preload4 from "../../../Assets/Images/Wizard/Mobile-frames/Line-3/40.svg";
import Line3M_preload5 from "../../../Assets/Images/Wizard/Mobile-frames/Line-3/50.svg";

import Line4M_preload1 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/10.svg";
import Line4M_preload2 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/20.svg";
import Line4M_preload3 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/30.svg";
import Line4M_preload4 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/40.svg";
import Line4M_preload5 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/50.svg";
import Line4M_preload6 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/60.svg";
import Line4M_preload7 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/70.svg";
import Line4M_preload8 from "../../../Assets/Images/Wizard/Mobile-frames/Line-4/80.svg";

const ImagePreloader = () => {
  return (
    <div hidden>
      <img alt="" src={Line1_preload1} />
      <img alt="" src={Line1_preload2} />
      <img alt="" src={Line1_preload3} />
      <img alt="" src={Line1_preload4} />
      <img alt="" src={Line1_preload5} />
      <img alt="" src={Line1_preload6} />
      <img alt="" src={Line1_preload7} />
      <img alt="" src={Line1_preload8} />
      <img alt="" src={Line1_preload9} />
      <img alt="" src={Line1_preload10} />
      <img alt="" src={Line1_preload11} />
      <img alt="" src={Line1_preload12} />
      <img alt="" src={Line1_preload13} />
      <img alt="" src={Line1_preload14} />
      <img alt="" src={Line2_preload1} />
      <img alt="" src={Line2_preload3} />
      <img alt="" src={Line2_preload4} />
      <img alt="" src={Line2_preload5} />
      <img alt="" src={Line2_preload6} />
      <img alt="" src={Line2_preload7} />
      <img alt="" src={Line2_preload8} />
      <img alt="" src={Line3_preload1} />
      <img alt="" src={Line3_preload2} />
      <img alt="" src={Line3_preload3} />
      <img alt="" src={Line3_preload4} />
      <img alt="" src={Line3_preload5} />
      <img alt="" src={Line3_preload6} />
      <img alt="" src={Line3_preload7} />
      <img alt="" src={Line4_preload1} />
      <img alt="" src={Line4_preload2} />
      <img alt="" src={Line4_preload3} />
      <img alt="" src={Line4_preload4} />
      <img alt="" src={Line4_preload5} />
      <img alt="" src={Line4_preload6} />
      <img alt="" src={Line4_preload7} />
      <img alt="" src={Line4_preload8} />
      <img alt="" src={Line4_preload9} />
      <img alt="" src={Line4_preload10} />
      <img alt="" src={Line4_preload11} />
      <img alt="" src={Line4_preload12} />
      <img alt="" src={Line4_preload13} />
      <img alt="" src={Line4_preload14} />

      <img alt="" src={Line1M_preload1} />
      <img alt="" src={Line1M_preload2} />
      <img alt="" src={Line1M_preload3} />
      <img alt="" src={Line1M_preload4} />
      <img alt="" src={Line1M_preload5} />
      <img alt="" src={Line1M_preload6} />
      <img alt="" src={Line1M_preload7} />
      <img alt="" src={Line1M_preload8} />
      <img alt="" src={Line2M_preload1} />
      <img alt="" src={Line2M_preload3} />
      <img alt="" src={Line2M_preload4} />
      <img alt="" src={Line2M_preload5} />
      <img alt="" src={Line3M_preload1} />
      <img alt="" src={Line3M_preload2} />
      <img alt="" src={Line3M_preload3} />
      <img alt="" src={Line3M_preload4} />
      <img alt="" src={Line3M_preload5} />
      <img alt="" src={Line4M_preload1} />
      <img alt="" src={Line4M_preload2} />
      <img alt="" src={Line4M_preload3} />
      <img alt="" src={Line4M_preload4} />
      <img alt="" src={Line4M_preload5} />
      <img alt="" src={Line4M_preload6} />
      <img alt="" src={Line4M_preload7} />
      <img alt="" src={Line4M_preload8} />
    </div>
  );
};

export default ImagePreloader;
